import { TCypher } from "../types"
import { get, post } from "./axiosClient"

type GetCypherProps = {
    token: string,
    id: number
}


type GetUserCypherProps = {
    token: string
}


type GetCypherResponse = {
    cypher?: TCypher,
    errorMessage?: string
}


export const getUserCypher = async ({ token }: GetUserCypherProps): Promise<GetCypherResponse> => {
    return await get({
        params: {},
        path: 'websystem/cypher',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { cypher: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}


export const getCypher = async ({ id, token }: GetCypherProps): Promise<GetCypherResponse> => {
    return await get({
        params: { id: id },
        path: 'websystem/cypher',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { cypher: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}

type GetStarsProps = {
    cypherId: number,
    token: string
}

type GetStarsResponse = {
    stars?: number,
    errorMessage?: string
}

export const getStars = async ({ cypherId, token }: GetStarsProps): Promise<GetStarsResponse> => {
    return await get({
        params: { cypherId: cypherId },
        path: 'websystem/cypher/stars',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { stars: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}

type SetStarsProps = {
    cypherId: number,
    token: string,
    stars: number
}

export const setStars = async ({ cypherId, token, stars }: SetStarsProps): Promise<GetStarsResponse> => {
    return await post({
        data: {},
        params: {
            cypherId: cypherId,
            stars: stars
        },
        path: 'websystem/cypher/stars',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { stars: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}